import React from 'react';
import clsx from 'clsx';

interface ProgressBarProps {
  className?: string;
  progress?: number;
  lighter?: boolean;
  rounded?: boolean;
}

export const ProgressBar = ({
  className,
  progress = 0,
  lighter = false,
  rounded = false,
}: ProgressBarProps) => (
  <div
    className={clsx('w-full h-2 bg-gray-200', rounded && 'rounded', className)}
  >
    <div
      className={clsx(
        'h-2',
        lighter ? 'bg-pt-xanadu' : 'bg-pt-primary',
        progress < 100 && 'rounded-r',
      )}
      style={{
        width: `${progress}%`,
      }}
    />
  </div>
);
